/* istanbul ignore file */
import { deleteDataDogCookies } from '../../features/tracking/trackers/datadog/cookies.datadog';
import { getDataDogLoggerOptions } from '../../features/tracking/trackers/datadog/config.datadog';
import { initLogger } from '@doxyme/analytics';

export const initializeLogger = (): void => {
  deleteDataDogCookies();
  initLogger(getDataDogLoggerOptions());
};
